// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import ProductionOders from "../views/ProductionOders.vue";

export default [
  {
    path: "/orders",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Órdenes de pedido",
        component: ProductionOders,
        meta: {
          title: "Órdenes de pedido",
        },
      },
    ],
  },
];
